window.addEventListener('scroll', function() {
    const fixedFooter = document.querySelector('.footer-sticky.scroll');
    const chatButton = document.querySelector('#dummy-chat-button-iframe');
    const ShopifyChat = document.querySelector('#ShopifyChat');
    const isScroll = window.scrollY > 100;
    
    fixedFooter.classList.toggle('is-scroll', isScroll);
    if (chatButton !== null) {
        chatButton.classList.toggle('is-scroll', isScroll);
    }
    if (ShopifyChat !== null) {
        ShopifyChat.classList.toggle('is-scroll', isScroll);
    }
});
  